<template>
  <div class="wrap">
    <div class="head">
      <div class="logo">
        <router-link exact to="/" tag="div">
          <img src="../assets/idImage/logo.png" alt="" />
        </router-link>
      </div>
      <div class="nav">
        <!-- 印尼官网暂时不要其他产品
          <li class="nav-product">
          <router-link
            to=""
            tag="div"
            :class="pagePath.includes('/product') ? 'high-light' : ''"
          >
            Product
            {{ $t("product") }}
          </router-link>
          <div class="triangle"></div>
          <div class="box">
            <p>
              <router-link
                style="height: 12px;marginTop:26px; line-height: 10px;"
                tag="div"
                to="/product/BlackList"
                :class="pagePath.includes('/product/BlackList') ? 'high-light' : ''"
              >
              {{ $t("BlackList") }}
              </router-link>
            </p>
            <p>
              <router-link
                style="height: 12px;marginTop:26px; line-height: 10px;"
                tag="div"
                to="/product/ocr"
                :class="pagePath.includes('/product/ocr') ? 'high-light' : ''"
              >
              {{ $t("OCR") }}
                OCR  Information Identification
              </router-link>
            </p>
            <p>
              <router-link
              style="height: 12px;marginTop:26px; line-height: 10px;"
                tag="div"
                to="/product/face"
                :class="pagePath.includes('/product/face') ? 'high-light' : ''"
              >
              {{ $t("Face") }}
                Face Recognition
              </router-link>
            </p>

            <p>
              <router-link
              style="
                  height: 12px;
                  marginTop: 28px;
                  marginBottom: 30px;
                  line-height: 10px;
                "
                tag="div"
                to="/product/risk"
                :class="pagePath.includes('/product/risk') ? 'high-light' : ''"
              >
             {{ $t("Risk") }}
                Intelligent Risk Control
              </router-link>
            </p>
            <p>
              <router-link
              style="
                  height: 12px;
                  marginTop: 28px;
                  marginBottom: 30px;
                  line-height: 10px;
                "
                tag="div"
                to="/product/intelligent"
                :class="pagePath.includes('/product/intelligent') ? 'high-light' : ''"
              >
             {{ $t("zhinengdaoliu") }}
                Intelligent Risk Control
              </router-link>
            </p>
            <p>
              <router-link
              style="
                  height: 12px;
                  marginTop: 28px;
                  marginBottom: 30px;
                  line-height: 10px;
                "
                tag="div"
                to="/product/score"
                :class="pagePath.includes('/product/score') ? 'high-light' : ''"
              >
             {{ $t("xinyongbaogao") }}
                Intelligent Risk Control
              </router-link>
            </p>

            <div class="box-b">
              <p>
                <router-link tag="div" to="/product/face" :class=" pagePath.includes('/product/face') ? 'high-light' : '' ">
                  Face Recognition
                </router-link>
              </p>
              <p>
                <router-link tag="div" to="/product/ocr" :class=" pagePath.includes('/product/ocr') ? 'high-light' : '' " >
                  OCR Information Identification
                </router-link>
              </p>
              <p>
                <router-link tag="div" to="/product/risk" :class=" pagePath.includes('/product/risk') ? 'high-light' : '' "  >
                  Intelligent Risk Control
                </router-link>
              </p>
            </div>
          </div>
        </li> -->
        <li>
          <router-link
            tag="div"
            to="/product/score"
            :class="pagePath.includes('/product/score') ? 'high-light' : ''"
          >
          {{ $t("xinyongbaogao") }}
          <!-- Intelligent Risk Control -->
          </router-link>
        </li>
        <li>
          <router-link
            tag="div"
            to="/usecases"
            :class="pagePath.includes('/usecases') ? 'high-light' : ''"
          >
          {{ $t("useCases") }}
            <!-- Use Cases -->
          </router-link>
        </li>
        <li>
          <router-link
            tag="div"
            to="/news"
            :class="pagePath.includes('/news') ? 'high-light' : ''"
          >
          {{ $t("News") }}
            <!-- News -->
          </router-link>
        </li>
        <li class="nav-Company">
          <router-link
            to="/company/aboutus"
            tag="div"
            :class="pagePath.includes('/company') ? 'high-light' : ''"
          >
           {{ $t("Company") }}
            <!-- Company -->
          </router-link>
          <!-- <div class="triangle"></div> -->
          <div class="box">
            <!-- <p>
              <router-link
                style="
                  height: 12px;
                  marginTop: 28px;
                  marginBottom: 26px;
                  line-height: 10px;
                "
                tag="div"
                to="/company/joinus"
                :class="
                  pagePath.includes('/company/joinus') ? 'high-light' : ''
                "
              >
              {{ $t("joinUs") }}
              </router-link>
            </p> -->
            <!-- <p>
              <router-link
                style="
                  height: 12px;
                  marginTop: 28px;
                  marginBottom: 30px;
                  line-height: 10px;
                "
                tag="div"
                to="/company/aboutus"
                :class="
                  pagePath.includes('/company/aboutus') ? 'high-light' : ''
                "
              >
              {{ $t("aboutUs") }}
              </router-link>
            </p> -->

            <!-- <div class="box-b">
              <span>
                <router-link
                  tag="div"
                  to="/company/aboutus"
                  :class="
                    pagePath.includes('/company/aboutus') ? 'high-light' : ''
                  "
                >
                  About Us
                </router-link>
              </span>
              <span>
                <router-link
                  tag="div"
                  to="/company/joinus"
                  :class="
                    pagePath.includes('/company/joinus') ? 'high-light' : ''
                  "
                >
                  Join Us
                </router-link>
              </span>
            </div> -->
          </div>
        </li>
        <li>
          <router-link
            tag="div"
            to="/contactus"
            :class="pagePath.includes('/contactus') ? 'high-light' : ''"
          >
          {{ $t("contactUs") }}
            <!-- Contact Us -->
          </router-link>
        </li>
        <li>
          <router-link
            tag="div"
            to="/privacy"
            :class="pagePath.includes('/privacy') ? 'high-light' : ''"
          >
          {{ $t("privacy") }}
            <!-- 隐私政策 -->
          </router-link>
        </li>
      </div>
      <!-- 国际化小块 暂时不要-->
      <div class="language">
        <!-- 下拉框 -->
        <div class="language-box">
          <!-- 印尼 -->
          <span>{{nowLanguage}}</span>
          <i class='el-icon-arrow-down el-icon--right'></i>
        </div>
        <div class='triangle-lang triangle-user'></div>
        <div class="language-menu">
          <p @click="changeLang('ID')" :class="nowLanguage=='ID'?'high-light':''">ID</p>
          <p @click="changeLang('EN')" :class="nowLanguage=='EN'?'high-light':''">EN</p>
        </div>
      </div>
      <!-- <div class="language">
        旧的 
        <div class="language-img">
          <img src="../assets/image/language.png" alt="" />
        </div>
        <div class="language-change">
          <span @click="funcShowAllCameras">{{
            flagShowCameras ? "中文" : "EngLish"
          }}</span>
        </div>
      </div> -->
      <!-- <div class="language" @click="funcShowAllCameras">
        <div class="language-img">
          <img src="../assets/image/language.png" alt="" />
        </div>
        <div class="language-change">
          <span>{{ $t("language") }}</span>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  components: {},
  data() {
    return {
      // fixedHeader: false,
      pagePath: "",
      nowLanguage:'',
      flagShowCameras: true,
    };
  },
  // computed: {
  //   routerTitle() {
  //     return this.$route.path.split('/').map(p=>!!p)
  //   }
  // },
  created() {
    this.pagePath = this.$route.path;
    this.flagShowCameras = this.$i18n.locale === "en_US";
    let language;
    language=localStorage.getItem('lang')?localStorage.getItem('lang'):'id';
    if(language=='en_US'){
      this.nowLanguage='EN';
      this.$i18n.locale='en_US';
    }else{
      this.nowLanguage='ID';
      this.$i18n.locale='id';
    }
   
    // this.nowLanguage=localStorage.getItem('lang')
    // //获取滚动条高度处理头部导航
    // window.onscroll = () =>{
    //   // console.log(e)
    //   // this.fixedHeader = document.documentElement.scrollTop >= this.$refs.container.offsetTop
    //   this.fixedHeader = document.documentElement.scrollTop >= 60
    //   // this.fixedHeader = document.documentElement.scrollTop >= this.$refs.container.offsetTop-60
    //   // eslint-disable-next-line no-console
    //   console.log(this.fixedHeader)
    // }
  },
  methods: {
    //  funcShowAllCameras() {
    //   this.flagShowCameras = this.flagShowCameras ? false : true;
    //   if (this.flagShowCameras == true) {
    //     // 变更语言环境
    //     this.$i18n.locale = "en";
    //     // 本地存储语言环境
    //     localStorage.setItem("lang", "en_US");
    //   } else {
    //     this.$i18n.locale = "zh";
    //     localStorage.setItem("lang", "zh_CN");
    //   }
    // },
    funcShowAllCameras() {
      this.flagShowCameras = !this.flagShowCameras;
      if (this.flagShowCameras) {
        // 变更语言环境
        this.$i18n.locale = "en_US";
        // 本地存储语言环境
        localStorage.setItem("lang", "en_US");
      } else {
        this.$i18n.locale = "zh_CN";
        localStorage.setItem("lang", "zh_CN");
      }
      window.location.reload();
    },
    changeLang(item){
      this.nowLanguage=item;
      if(item=='EN'){
        this.$i18n.locale = "en_US";
        localStorage.setItem("lang", "en_US");
        console.log('英语')
      }else{
        this.$i18n.locale = "id";
        localStorage.setItem("lang", "id");
        console.log('印尼')
      }
       window.location.reload();
    }
  },
};
</script>
<style lang="less" scoped>
.high-light {
  color: #00d2ff;
}
.wrap {
  width: 100%;
  height: 60px;
  position: absolute;
  top: 0;
  z-index: 999;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  .head {
    width: 1400px;
    // width: 100%;
    height: 60px;
    margin: auto;
    display: flex;
    align-items: center;
    .logo {
      width: 520px;
      align-items: center;
      cursor: pointer;
      img {
        // width: 184px;
      }
    }
    .nav {
      display: flex;
      width: 66%;
      height: 60px;
      justify-content: space-around;
      li {
        // width: 168px;
        height: 60px;
        line-height: 60px;
      }
      li:hover {
        cursor: pointer;
        color: #00d2ff;
      }
      .nav-product {
        position: relative;
        .triangle {
          width: 0px;
          height: 0px;
          border-width: 12px;
          border-style: solid;
          border-color: transparent transparent #fff transparent;
          position: absolute;
          left: 22px;
          top: 40px;
          display: none;
        }
        .box {
          min-width: 196px;
          box-shadow: 0px 4px 6px 0px rgba(21, 20, 41, 0.42);
          border-radius: 4px;
          background: #fff;
          position: absolute;
          left: -64px;
          // left: -56%;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #130e1e;
          text-align: center;
          display: none;
          // p{
          //   width: 100%;
          //   height: 100%;
          //   white-space:nowrap; 
          // }
          p:hover {
            color: #00d2ff;
          }
        }
        // .box {
        //   width: 200px;
        //   // height: 45px;
        //   color: black;
        //   box-shadow: 0px 4px 6px 0px rgba(21, 20, 41, 0.42);
        //   border-radius: 4px;
        //   font-weight: 400;
        //   position: absolute;
        //   top: 60px;
        //   left: -40px;
        //   background: #fff;
        //   // display: none;
        //   .box-b {
        //     height: 45px;
        //     line-height: 45px;
        //     display: flex;
        //     justify-content: space-around;
        //     span:hover {
        //       color: #00d2ff;
        //     }
        //   }
        // }
      }
      .nav-product:hover .box {
        display: block;
      }
      .nav-product:hover .triangle {
        display: block;
      }
      .nav-Company {
        position: relative;
        .triangle {
          width: 0px;
          height: 0px;
          border-width: 12px;
          border-style: solid;
          border-color: transparent transparent #fff transparent;
          position: absolute;
          left: 28px;
          top: 40px;
          display: none;
        }
        .box {
          min-width: 196px;
          box-shadow: 0px 4px 6px 0px rgba(21, 20, 41, 0.42);
          border-radius: 4px;
          background: #fff;
          position: absolute;
          left: -58px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #130e1e;
          text-align: center;
          display: none;
          p:hover {
            color: #00d2ff;
          }
        }
        // .box {
        //   width: 280px;
        //   height: 45px;
        //   color: black;
        //   box-shadow: 0px 4px 6px 0px rgba(21, 20, 41, 0.42);
        //   border-radius: 4px;
        //   font-weight: 400;
        //   position: absolute;
        //   top: 60px;
        //   left: -40px;
        //   background: #fff;
        //   display: none;
        //   .box-b {
        //     height: 45px;
        //     line-height: 45px;
        //     display: flex;
        //     justify-content: space-around;
        //     span:hover {
        //       color: #00d2ff;
        //     }
        //   }
        // }
      }
      .nav-Company:hover .box {
        display: block;
      }
      .nav-Company:hover .triangle {
        display: block;
      }
    }
    // 国际化
    .language:hover .triangle-lang{
        display: block;
    }
    .language:hover .language-menu {
        display: block;
    }
    .language {
      min-width: 120px;
      height: 66px;
      display: flex;
      align-items: center;
      margin-right: 16px;
      // margin-left: 16px;
      cursor: pointer;
      position: relative;
      .language-box{
        min-width: 120px;
        // background: green;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .triangle-lang{
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent #fff transparent;
          -webkit-filter: drop-shadow(0 -1px 3px rgba(0,0,0,.2));
          filter: drop-shadow(0 -1px 3px rgba(0,0,0,.2));
          position: absolute;
          left: 50px;
          top: 47px;
          display: none;
      }
      .language-menu{
        position: absolute;
        top: 63px;
        left: 23px;
        min-width: 70px;
        background: #fff;
        color: #000;
        line-height: 36px;
        text-align: center;
        font-weight: 400;
        box-shadow: 0px 4px 8px 0px rgba(21, 20, 41, 0.42);
        padding: 12px 0;
        border-radius: 4px;
        box-sizing: border-box;
        display: none;
      }
      .language-menu p:hover{
        color: #00d2ff;
      }
      .language-img {
        margin: auto;
        margin-right: 5px;
        img {
          width: 16px;
          margin-top: 4px;
        }
      }
      .language-change {
        flex: 1;
        margin: auto;
        font-size: 16px;
        color: #fff;
        font-family: Acumin Variable Concept;
      }
    }
  }
}
</style>
